import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface EmptyStateProps {
  /** Mono uppercase kicker above the title, e.g. "Start here". */
  eyebrow?: string
  title: string
  description?: ReactNode
  /** Primary action, usually a Link or button in the .wbtn language. */
  action?: ReactNode
  className?: string
}

/**
 * Empty-state block in the workspace language — mono eyebrow, display-font
 * title, one line of guidance. Used by list screens and as the DataTable's
 * `emptyState`. (The two dashboard homes keep their own dash-empty blocks;
 * those are part of the mosaic design.)
 */
export function EmptyState({ eyebrow, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('empty-state', className)}>
      {eyebrow && <span className="dash-label">{eyebrow}</span>}
      <strong>{title}</strong>
      {description && <p>{description}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  )
}
